import { redirect } from "@tanstack/react-router"
import { getAccessToken, removeTokens } from "@/shared/lib/token/token"
import type { AuthState } from "./auth.model"

export const requireAuthenticatedSession = (
  auth: Pick<AuthState, "isAuthenticated"> | undefined
) => {
  // The router context can still contain the previous render's authenticated state
  // after a failed refresh. Check the credential at the point the loader will use it.
  const token = getAccessToken()
  if (!token) removeTokens()
  if (!auth?.isAuthenticated || !token) {
    throw redirect({ to: "/" })
  }
}

export const withAuthenticatedSession = async <T>(
  auth: Pick<AuthState, "isAuthenticated"> | undefined,
  load: () => Promise<T>
): Promise<T> => {
  requireAuthenticatedSession(auth)
  let result: T
  try {
    result = await load()
  } catch (error) {
    // Any step in a loader can lose its credential, including calls that recover
    // from their own API errors. Preserve other failures while the session exists.
    requireAuthenticatedSession(auth)
    throw error
  }
  requireAuthenticatedSession(auth)
  return result
}
